const translation = {
  tags: {
    other: 'Outro',
    medical: 'Médico',
    videos: 'Vídeos',
    productivity: 'Produtividade',
    utilities: 'Utilidades',
    social: 'Social',
    finance: 'Financiar',
    image: 'Imagem',
    education: 'Educação',
    design: 'Projetar',
    business: 'Negócio',
    weather: 'Tempo',
    news: 'Notícia',
    agent: 'Agente',
    entertainment: 'Entretenimento',
    search: 'Procurar',
    travel: 'Viajar',
  },
  allTags: 'Todas as tags',
  searchTags: 'Tags de pesquisa',
}

export default translation
